import { createFileRoute } from "@tanstack/react-router";
import AdminWeeklyComments from "@/pages/admin/AdminWeeklyComments";

export const Route = createFileRoute("/admin/comentarios-modulos")({
  component: AdminWeeklyComments,
});
